/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/baglass/js/baglass/app/plugins/Button',
	'../../app/nls/StringResources'
], function(BaseClass, resources) {

	var ModeButton = BaseClass.extend({
		init: function() {
			ModeButton.inherited('init', this, arguments);
			this.pressedTitle = resources.get('togglePreviewModeLabel');
			this.unpressedTitle = resources.get('toggleEditModeLabel');
		},

		setPressed: function() {
			ModeButton.inherited('setPressed', this, arguments);
			this.$el.attr('title',this.pressedTitle);
			this.getIcon().attr('aria-label', this.pressedTitle);
		},

		setUnpressed: function() {
			ModeButton.inherited('setUnpressed', this, arguments);
			this.$el.attr('title',this.unpressedTitle);
			this.getIcon().attr('aria-label', this.unpressedTitle);
		},

		getIcon: function() {
			if (!this.$icon) {
				this.$icon = this.$el.find('*[role=img],img');
			}
			return this.$icon;
		}
	});

	return ModeButton;
});
